import {extendTheme} from '@chakra-ui/react'
import overrides from '@salesforce/retail-react-app/app/theme'
import 'react-phone-input-2/lib/style.css'
import semantics from './semantics'
import {
    delonghiProjectOverrides,
    kenwoodProjectOverrides,
    nutribulletProjectOverrides,
    braunProjectOverrides,
} from './overrides'
import Button from './components/base/button'
import Dropdown from './components/base/dropdown'
import Breadcrumb from './components/project/breadcrumb'
import PriceCard from './components/project/price-card'
import StockLabel from './components/project/stock-label'
import Survey from './components/base/survey'
import Swiper from './components/base/swiper'
import ProductThumbnail from './components/project/product-thumbnail'
import ProductDetailDescription from './components/project/product-detail-description'
import ProductCompare from './components/project/product-compare'
import ProductHeader from './components/project/product-header'
import BenefitCard from './components/project/BenefitCard'
import Feedback from './components/project/feedback'
import ProductList from './components/project/product-list'
import Accordion from './components/base/accordion'
import AddressFields from './components/project/address-fields'
import Adyen from './components/project/adyen'
import Awards from './components/project/awards'
import CategoryLinks from './components/project/category-links'
import SortByAccordionItem from './components/project/sort-by-accordion-item'
import Refinements from './components/project/refinements'
import ProductFilterDrawer from './components/project/product-filter-drawer'
import ColorRefinements from './components/project/color-refinements'
import ProductTile from './components/project/product-tile'
import Header from './components/project/header'
import HelpMeChoose from './components/project/help-me-choose'
import HeroBannerText from './components/project/hero-banner-text'
import CheckBoxRefinements from './components/project/checkbox-refinements'
import Checkbox from './components/base/checkbox'
import CountrySelector from './components/project/country-selector'
import CountrySelectorFooter from './components/project/country-selector-footer'
import DatePicker from './components/project/date-picker'
import Drawer from './components/base/drawer'
import DrawerMenu from './components/project/drawer-menu'
import EnergyLabel from './components/project/energy-label'
import ExtraSwiper from './components/project/extra-swiper'
import Field from './components/project/field'
import Filters from './components/project/filters'
import Footer from './components/project/footer'
import GridCard from './components/project/grid-card'
import GridTemplate from './components/project/grid-template'
import Iconbox from './components/project/iconbox'
import ImageGallery from './components/project/image-gallery'
import ImageGalleryDivider from './components/project/image-gallery-divider'
import InfoPopover from './components/project/info-popover'
import InformativeLabel from './components/project/informative-label'
import ItemPriceCustom from './components/project/item-price-custom'
import KenwoodMenu from './components/project/kenwood-menu'
import KenwoodMenuCard from './components/project/kenwood-menu-card'
import KeyFeatures from './components/project/key-features'
import Klarna from './components/project/klarna'
import LinksList from './components/project/links-list'
import ListMenu from './components/project/list-menu'
import ListMenuCard from './components/project/list-menu-card'
import Login from './components/project/login'
import Manuals from './components/project/manuals'
import MarketingPreferences from './components/project/marketing-preferences'
import MiniCartPopover from './components/project/mini-cart-popover'
import Modal from './components/base/modal'
import NewsletterBanner from './components/project/newsletter-banner'
import OmnibusPrice from './components/project/omnibus-price'
import PaddingBlock from './components/project/padding-block'
import PageHeader from './components/project/page-header'
import Paperless from './components/project/paperless'
import PaperlessBanner from './components/project/paperless-banner'
import Popover from './components/base/popover'
import PlpGridCard from './components/project/plp-grid-card'
import PlpWhiteBanner from './components/project/plp-white-banner'
import PlpBannerPromo from './components/project/plp-banner-promo'
import PreFooter from './components/project/pre-footer'
import ProductComparePlp from './components/project/product-compare-plp'
import ProductDocumentation from './components/project/product-documentation'
import ProductView from './components/project/product-view'
import PromoSlider from './components/project/promo-slider'
import Radio from './components/base/radio'
import RadioRefinements from './components/project/radio-refinements'
import RecommendedProducts from './components/project/recommended-products'
import Bundle from './components/project/bundle'
import Search from './components/project/search'
import ShopTheLook from './components/project/shop-the-look'
import Sorting from './components/project/sorting'
import SovraHeader from './components/project/sovra-header'
import LoadingSpinner from './components/project/loading-spinner'
import Steps from './components/project/steps'
import StickyMenu from './components/project/sticky-menu'
import TextGroup from './components/project/text-group'
import UserNewsletterBanner from './components/project/user-newsletter-banner'
import Confirmation from './components/project/confirmation'
import CancellationConfirmationModal from './components/project/cancellation-confrimation-modal'
import VatLabel from './components/project/vat-label'
import VatValidator from './components/project/vat-validator'
import ProductRegistration from './components/project/product-registration'
import ProductRegistrationStepper from './components/project/product-registration-stepper'
import ProductRegistrationProducts from './components/project/product-registration-products'
import ProductRegistrationLogin from './components/project/product-registration-login'
import ProductRegistrationForm from './components/project/product-registration-form'
import ProductRegistrationConfirm from './components/project/product-registration-confirm'
import Moodboard from './components/project/moodboard'
import ConfirmationModal from './components/project/confirmation-modal'
import Wishlist from './components/project/wishlist'
import Account from './components/project/account'
import DashboardComponents from './components/project/dashboard-components'
import RepairTrackingTool from './components/project/repair-tracking-tool'
import Orders from './components/project/orders'
import Faq from './components/project/faq'
import Gallery from './components/project/gallery'
import ContentSlider from './components/project/content-slider'
import WeeeFee from './components/project/weee-fee'
import Stories from './components/project/stories'
import HeroBannerCountdown from './components/project/hero-banner-countdown'
import ProductMoodboard from './components/project/product-moodboard'
import ContactUs from './components/project/contact-us'
import ContentCards from './components/project/content-cards'
import Disclaimer from './components/project/disclaimer'
import Pricing from './components/project/pricing'
import Subscriptions from './components/project/subscriptions'
import ThreekitWidgetContainer from './components/project/threekit-widget-container'
import CustomToast from './components/project/custom-toast'
import Policies from './components/project/policies'
import Video from './components/project/video'
import HeroBanner from './components/project/hero-banner'
import SideCard from './components/project/side-card'
import PDPBannerPromo from './components/project/pdp-banner-promo'
import Benefits from './components/project/benefits'
import CartSecondaryButtonGroup from './components/project/cart-secondary-button-group'
import OrderHistory from './components/project/order-history'
import ProductDetailBanner from './components/project/product-detail-banner'
import WarrantySectionCart from './components/project/warranty-section-cart'
import WarrantySelectorModal from './components/project/warranty-selector-modal'

// SHARED
import Cart from './components/project/Cart'
import GetMoreButton from './components/project/get-more-button'
import OrderSummary from './components/project/order-summary'
import ProductItem from './components/project/product-item'
import QuantityPicker from './components/project/quantity-picker'
import GalleryModal from './components/project/gallery-modal'
import ServiceCenterLocator from './components/project/serviceCenterLocator'
import RapidLinksModule from './components/project/rapid-links-module'
import AddressCheckModal from './components/project/address-check-modal'
//SHARED
import ActionCard from './components/project/action-card'
import AddressDisplay from './components/project/address-display'
import Checkout from './components/project/checkout'
import GigyaGlobal from './components/project/gigya-global'
import GigyaModal from './components/project/gigya-modal'
import ErrorAndMaintenancePage from './components/project/error-and-maintenance-page'
import Employee from './components/project/employee'
import FreeItemPromo from './components/project/free-item-promo'
import nutribulletomponentOverrides from './_nutribullet/componentOverrides'
import kenwoodComponentOverrides from './_kenwood/componentOverrides'
import braunComponentOverrides from './_braun/componentOverrides'
import WhatsInTheBox from './components/project/whats-in-the-box'
import Features from './components/project/features'
import ProductVariants from './components/project/product-variants'

//KENWOOD Recipes
import RecipeTile from './components/project/recipe-tile'
import RecipeHeroBanner from './components/project/recipe-hero-banner'
import RecipeList from './components/project/recipe-list'
import RecipeDetails from './components/project/recipe-details'

//BRAUN
import BraunMenu from './components/project/braun-menu'

const components = {
    ...overrides.components,
    Accordion,
    Account,
    ActionCard,
    AddressCheckModal,
    AddressDisplay,
    AddressFields,
    Adyen,
    Awards,
    BenefitCard,
    Breadcrumb,
    Bundle,
    Button,
    CancellationConfirmationModal,
    Cart,
    CategoryLinks,
    CheckBoxRefinements,
    Checkbox,
    Checkout,
    ColorRefinements,
    Confirmation,
    ConfirmationModal,
    ContactUs,
    ContentCards,
    ContentSlider,
    CountrySelector,
    CountrySelectorFooter,
    CustomToast,
    DashboardComponents,
    DatePicker,
    Disclaimer,
    Drawer,
    DrawerMenu,
    Dropdown,
    Employee,
    EnergyLabel,
    ErrorAndMaintenancePage,
    ExtraSwiper,
    Faq,
    Feedback,
    Field,
    Filters,
    Footer,
    FreeItemPromo,
    Gallery,
    GalleryModal,
    GetMoreButton,
    GigyaGlobal,
    GigyaModal,
    GridCard,
    GridTemplate,
    Header,
    HelpMeChoose,
    HeroBannerCountdown,
    HeroBannerText,
    Iconbox,
    ImageGallery,
    ImageGalleryDivider,
    InfoPopover,
    InformativeLabel,
    ItemPriceCustom,
    KeyFeatures,
    Klarna,
    LinksList,
    ListMenu,
    ListMenuCard,
    LoadingSpinner,
    Login,
    Manuals,
    MarketingPreferences,
    MiniCartPopover,
    Modal,
    Moodboard,
    NewsletterBanner,
    OmnibusPrice,
    OrderSummary,
    Orders,
    PaddingBlock,
    PageHeader,
    Paperless,
    PaperlessBanner,
    PlpBannerPromo,
    PlpGridCard,
    PlpWhiteBanner,
    Popover,
    PreFooter,
    PriceCard,
    Pricing,
    ProductCompare,
    ProductComparePlp,
    ProductDetailDescription,
    ProductDetailBanner,
    ProductDocumentation,
    ProductFilterDrawer,
    ProductHeader,
    ProductItem,
    ProductList,
    ProductMoodboard,
    ProductRegistration,
    ProductRegistrationConfirm,
    ProductRegistrationForm,
    ProductRegistrationLogin,
    ProductRegistrationProducts,
    ProductRegistrationStepper,
    ProductThumbnail,
    ProductTile,
    ProductVariants,
    ProductView,
    PromoSlider,
    QuantityPicker,
    Radio,
    RadioRefinements,
    RapidLinksModule,
    RecommendedProducts,
    Refinements,
    RepairTrackingTool,
    Search,
    ServiceCenterLocator,
    ShopTheLook,
    SortByAccordionItem,
    Sorting,
    SovraHeader,
    Steps,
    StickyMenu,
    StockLabel,
    Stories,
    Subscriptions,
    Survey,
    Swiper,
    TextGroup,
    ThreekitWidgetContainer,
    UserNewsletterBanner,
    VatLabel,
    VatValidator,
    WeeeFee,
    RecipeTile,
    RecipeHeroBanner,
    RecipeList,
    RecipeDetails,
    Wishlist,
    Policies,
    BraunMenu,
    WhatsInTheBox,
    Features,
    Video,
    HeroBanner,
    SideCard,
    PDPBannerPromo,
    Benefits,
    CartSecondaryButtonGroup,
    OrderHistory,
    WarrantySectionCart,
    WarrantySelectorModal,
}

// GLOBAL STYLES

const globalStyles = {
    '.editorial--html-block a:not(.chakra-button)': {
        color: 'text.tertiary !important',
        textDecoration: 'underline',
        fontWeight: '400',
        cursor: 'pointer',
        _hover: {
            opacity: '0.8',
        },
    },
}

// THEME SPECIFIC

const delonghiTheme = extendTheme({
    ...delonghiProjectOverrides,
    components,
    semanticTokens: {
        ...semantics('delonghi'),
    },
    styles: {global: globalStyles},
} as object)

const kenwoodComponents = {
    KenwoodMenu,
    KenwoodMenuCard,
    ...components,
}

/**
 * Kenwood theme is just a placeholder
 */
const kenwoodTheme = extendTheme(
    {
        ...kenwoodProjectOverrides,
        components: kenwoodComponents,
        semanticTokens: {
            ...semantics('kenwood'),
        },
        styles: {global: globalStyles},
    },
    kenwoodComponentOverrides,
)

/**
 * Nutribullet theme is just a placeholder
 */
const nutribulletTheme = extendTheme(
    {
        ...nutribulletProjectOverrides,
        components,
        semanticTokens: {
            ...semantics('nutribullet'),
        },
        styles: {global: globalStyles},
    },
    nutribulletomponentOverrides,
)

/**
 * Braun theme is just a placeholder
 */
const braunTheme = extendTheme(
    {
        ...braunProjectOverrides,
        components,
        semanticTokens: {
            ...semantics('braun'),
        },
        styles: {global: globalStyles},
    },
    braunComponentOverrides,
)

export {delonghiTheme, kenwoodTheme, nutribulletTheme, braunTheme}
